import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const ProductInformationLayout = lazy(() => import('.'));
const ProductInformationMenu = lazy(() => import('./menu'));
const ProductInformationList = lazy(() => import('./menu/list'));
const ProductInformationDetail = lazy(() => import('./detail'));

export const routeConfig: (RouteProps & { subChildren?: RouteProps[] })[] = [
  {
    path: '/product-information',
    element: <ProductInformationLayout />,
  },
  {
    path: '/product-information/menu',
    element: <ProductInformationMenu />,
    subChildren: [
      { path: '/product-information/menu/list', element: <ProductInformationList /> },
    ],
  },
  {
    path: '/product-information/detail/:id',
    element: <ProductInformationDetail />,
  },
];
